<template>
    <div :style="note">
        <div class="login-card">
            <el-form :rules="rules" ref="loginForm" v-loading="loading" element-loading-text="正在登录..."
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                :model="loginForm" class="loginContainer">
                <h3 class="loginTitle">数据资产全过程AI服务平台</h3>
                <el-divider><span style="font-size: 14px;color: #8c8c8c">管理员登录</span></el-divider>

                <el-form-item prop="username">
                    <el-input size="normal" type="text" v-model="loginForm.username" auto-complete="off"
                        placeholder="管理员账号" clearable prefix-icon="el-icon-user"
                        @keydown.enter.native="submitLogin"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input size="normal" type="password" v-model="loginForm.password" auto-complete="off"
                        placeholder="密码" clearable prefix-icon="el-icon-lock"
                        @keydown.enter.native="submitLogin"></el-input>
                </el-form-item>
                <el-form-item>
                    <div class="slide-verify-container">
                        <div class="slide-verify-track">
                            <div class="slide-verify-thumb" :style="{ left: sliderValue + '%' }" 
                                 @mousedown="startDrag"
                                 @touchstart="startDrag">
                                <i class="el-icon-arrow-right"></i>
                            </div>
                            <div class="slide-verify-text" :data-status="sliderValue === 100 ? 'success' : 'default'">
                                <i class="el-icon-success" v-if="sliderValue === 100"></i>
                                {{ sliderValue === 100 ? '验证通过' : '请按住滑块，拖动到最右边' }}
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <el-col :span="12" v-show="false">
                    <el-form-item prop="imageCode">
                        <el-input size="normal" type="text" v-model="loginForm.imageCode" auto-complete="off"
                            class="el-col-width" placeholder="验证码" clearable style="width: 80%"></el-input>
                    </el-form-item>
                </el-col>

                <el-form-item style="margin: 0">
                </el-form-item>
                <el-button size="normal" type="primary" style="width: 100%;" @click="submitLogin"
                    :disabled=forbidLogin>登录</el-button>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminLogin",
    data() {
        return {
            sliderValue: 0,
            loginUrl: 'admin/login',
            loading: false,
            forbidLogin: true,
            loginForm: {
                username: '',
                password: '',
                imageCode: '',
                rememberMe: true
            },
            rules: {
                username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            note: {
                backgroundImage: "url(" + require("../assets/img/manager_bg_.png") + ")",
                backgroundColor: "#f9f9f9",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                position: "absolute",
                backgroundSize: "cover",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }
    },
    mounted() {
        // 检查是否已登录
        if (window.localStorage.getItem('user') || window.sessionStorage.getItem('user')) {
            this.$router.push('/home');
        }
        this.refreshCaptcha(); // 初始化加载验证码
        this.getBlacklist(); // 
    },
    watch: {
        'loginForm.username': function (val, oldValue) {
            this.forbidLogin = !this.checkData();
        },
        'loginForm.password': function (val, oldValue) {
            this.forbidLogin = !this.checkData();
        },
        'sliderValue': function (val) {
            if (val === 100) {
                this.forbidLogin = !this.checkData();
            } else {
                this.forbidLogin = true;
            }
        }
    },
    methods: {
        formatTooltip(val) {
            return val === 100 ? '验证通过' : val > 0 ? `${val}%` : '请滑动验证';
        },
        startDrag(e) {
            e.preventDefault();
            const thumb = e.target.closest('.slide-verify-thumb');
            const track = e.target.closest('.slide-verify-track');
            const trackRect = track.getBoundingClientRect();
            const maxPos = trackRect.width - 40;

            const isTouchEvent = e.type === 'touchstart';
            const moveEventName = isTouchEvent ? 'touchmove' : 'mousemove';
            const endEventName = isTouchEvent ? 'touchend' : 'mouseup';

            const moveHandler = (moveEvent) => {
                const clientX = isTouchEvent ? moveEvent.touches[0].clientX : moveEvent.clientX;
                let posX = clientX - trackRect.left;
                posX = Math.max(0, Math.min(posX, trackRect.width - 40));

                // 实时计算滑块位置，不使用缓动效果
                this.sliderValue = Math.min(100, Math.round((posX / (trackRect.width - 40)) * 100));
                track.style.setProperty('--slider-progress', this.sliderValue);
                thumb.style.left = `${posX}px`;

                // 动态改变按钮颜色
                const progress = posX / (trackRect.width - 40);
                thumb.style.backgroundColor = `rgba(255, 255, 255, ${1 - progress * 0.2})`;

                // 防止文本选中和页面滚动
                moveEvent.preventDefault();
                return false;
            };

            const upHandler = () => {
                document.removeEventListener(moveEventName, moveHandler);
                document.removeEventListener(endEventName, upHandler);
                thumb.style.cursor = 'grab';

                if (this.sliderValue === 100) {
                    this.forbidLogin = !this.checkData();
                } else {
                    setTimeout(() => {
                        this.sliderValue = 0;
                        track.style.setProperty('--slider-progress', 0);
                        thumb.style.backgroundColor = '#fff';
                    }, 300);
                }
            };

            thumb.style.cursor = 'grabbing';
            document.addEventListener(moveEventName, moveHandler);
            document.addEventListener(endEventName, upHandler, { once: true });
            
            // 添加触摸事件特有的处理
            if (isTouchEvent) {
                document.body.style.overflow = 'hidden'; // 防止页面滚动
            }
        },

        refreshCaptcha() {
            this.$axios.get('/web/getAdminLoginCode').then(response => {
                this.loginForm.imageCode = 'sjzcdjadmin';
            }).catch(error => {
                this.$message.error(error.response?.data?.object || '验证码获取失败');
            });
        },

        getBlacklist() {
            this.getRequest('/web/company/user/getBlacklist').then(resp => {
                if (resp && Array.isArray(resp.data)) {
                    this.blacklist = resp.data; // 直接使用返回的数组
                }
            });
        },
        isBlacklisted(username) {
            return this.blacklist && this.blacklist.includes(username);
        },

        checkData() {
            return this.loginForm.username !== '' && this.loginForm.password !== '' && this.sliderValue === 100;
        },
        submitLogin() {
            this.$refs.loginForm.validate((valid) => {


                if (valid && !this.forbidLogin) {
                    if (!this.isBlacklisted(this.loginForm.username)) {
                        this.$message.error("账号或密码错误");
                        return false;
                    }
                    this.loading = true;
                    console.log(this.loginForm);
               
                    this.postKeyValueRequest('/web/doLogin', this.loginForm).then(resp => {
                        this.loading = false;
                        if (resp) {
                            var user = resp.data.user;
                            if (user.avatar === '') {
                                user.avatar = require('../assets/user_pic_middle.gif');
                            }
                            this.$store.commit('INIT_USER', JSON.stringify(user));
                            this.$router.push('/home');
                        }
                    }
                    );
                } else {
                    this.$message.error("请输入所有的字段!");
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
.login-card {
    position: absolute;
    right: 18%;
    top: 50%;
    transform: translateY(-50%);
    width: 350px;
    margin: 0;
    padding: 0;
}

.loginContainer {
    border-radius: 8px;
    width: 100%;
    padding: 25px;
    background: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: none !important;
    margin: 0;
}

.slide-verify-container {
    width: 100%;
    margin: 20px 0;
}

.slide-verify-track {
    position: relative;
    height: 40px;
    background-color: #f5f7fa;
    border-radius: 20px;
    border: 1px solid #dcdfe6;
    overflow: hidden;
    padding-right: 40px;
    box-sizing: border-box;
}

.slide-verify-track::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: calc(var(--slider-progress, 0) * 1%);
    background: linear-gradient(90deg, #409EFF, #67C23A);
    transition: width 0.2s ease;
}

.slide-verify-thumb {
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    transition: none;
    /* 移除过渡效果，实现即时跟随 */
    will-change: left;
    user-select: none;
    touch-action: none;
    -webkit-tap-highlight-color: transparent; /* 移除移动端点击高亮 */
    -webkit-user-select: none; /* Safari 特定属性 */
}

.slide-verify-thumb:active {
    cursor: grabbing;
    transform: scale(1.05);
}

.slide-verify-thumb i {
    color: #409EFF;
    font-size: 16px;
}

.slide-verify-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    z-index: 1;
}

.slide-verify-text i {
    margin-right: 5px;
    font-size: 16px;
}

.slide-verify-text[data-status="success"] {
    color: #fff;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    animation: fadeIn 0.3s ease;
    background-color: rgba(103, 194, 58, 0.9);
    border-radius: 20px;
    padding-right: 40px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
    from {
        opacity: 0.5;
    }

    to {
        opacity: 1;
    }
}

.slide-verify-text[data-status="default"] {
    color: #6cb3ff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.loginTitle {
    margin: 15px auto 20px auto;
    text-align: center;
    color: #505458;
}

.loginRemember {
    text-align: left;
    margin: 0 0 15px 0;
}
</style>